import styled from 'styled-components'
import Link from 'components/Link'

export default styled(Link)`
  font-size: 14px;
  line-height: 1.71;
  display: block;
`
